module.exports = __webpack_public_path__ + "892a00c2888cf8ff2adfd43b8266b41a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-24.svg
// module id = 568
// module chunks = 0